// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3M1Jc","icon":"SortAdornment_icon__Gzr68","up":"SortAdornment_up__3tyOC","down":"SortAdornment_down__1NoX0","active":"SortAdornment_active__RNgwS"};